module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c12-374eef6cc32731c1bb45d9d9edeb8c0d.jpg";